import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBed"><Path d="M2.5 10.5H21.5V17.5H2.5V10.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 10.5V4.5H4.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 4.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 17.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 17.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBed;
